export default "__VITE_ASSET__Du3omvW3__"